import { render, staticRenderFns } from "./UserVacations.vue?vue&type=template&id=21ddfadd&scoped=true"
import script from "./UserVacations.vue?vue&type=script&lang=js"
export * from "./UserVacations.vue?vue&type=script&lang=js"
import style0 from "./UserVacations.vue?vue&type=style&index=0&id=21ddfadd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ddfadd",
  null
  
)

export default component.exports